import React from 'react';

const Pagination = ({ currentPage, totalNoPages, onNextPage, onPreviousPage }) => {
  return (
    <div className="pagination">
      <button disabled={currentPage === 1} onClick={onPreviousPage}>
        Previous
      </button>
      <span>
        Page {currentPage} of {totalNoPages || 1}
      </span>
      <button
        disabled={currentPage === totalNoPages}
        onClick={onNextPage}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
